var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-checkbox",
        {
          attrs: { value: true, "unchecked-value": false },
          on: {
            change: function($event) {
              return _vm.groupByChange()
            }
          },
          model: {
            value: _vm.groupBy,
            callback: function($$v) {
              _vm.groupBy = $$v
            },
            expression: "groupBy"
          }
        },
        [_vm._v("Показывать по дням")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f463a9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f463a9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupByDateFilter.vue
// module id = null
// module chunks = 